// AUTO-GENERATED by sync-icons — do not edit.
import type { FC, SVGProps } from 'react';
const SvgHeartIcon: FC<SVGProps<SVGGElement>> = props => (
  <g {...props}>
    <path d="M16 3c-1.5 0-2.91.55-4 1.54A5.92 5.92 0 0 0 8 3C4.69 3 2 5.69 2 9c0 1.57.61 3.06 1.72 4.2l7.58 7.51c.2.19.45.29.7.29s.51-.1.7-.29l7.56-7.49A6.01 6.01 0 0 0 21.99 9c0-3.31-2.69-6-6-6z" />
  </g>
);
export default SvgHeartIcon;
SvgHeartIcon.displayName = 'SvgHeartIcon';
